/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiListApprovalActionsResponse,
  getCoinbaseEngUsersAccountManagementApiApiListApprovalActionsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiListApprovalActionsResponse';

export type ListApprovalActionsResult =
  CoinbaseEngUsersAccountManagementApiApiListApprovalActionsResponse;

const validateListApprovalActionsResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiListApprovalActionsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ListApprovalActionsResult data does not match contract.`,
      errors,
    );
  }
};

export const getListApprovalActionsUrl = ({
  additionalParams,
  baseUrl,
}: {
  additionalParams?: Record<string, unknown>;
  baseUrl?: string;
} = {}) => {
  const searchParams = new URLSearchParams();
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/v1/consensus/approval-actions${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ListApprovalActions
 * @Url /v1/consensus/approval-actions
 * @Auth Required
 */

export function useGetListApprovalActions(
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ListApprovalActionsResult | undefined;

export function useGetListApprovalActions(options?: FetchOptions): ListApprovalActionsResult;

export function useGetListApprovalActions(
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getListApprovalActionsUrl(options);
  const data = useFetch<ListApprovalActionsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateListApprovalActionsResult(data);
  }

  return data;
}

/**
 * Access ListApprovalActions fetch callback
 */
export const useGetListApprovalActionsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (additionalHeaders?: Record<string, string>) => {
      const url = getListApprovalActionsUrl();
      const resource = getResource<ListApprovalActionsResult>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateListApprovalActionsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ListApprovalActions without throwing to suspense
 * @Url /v1/consensus/approval-actions
 * @Auth Required
 */
export const useRefreshListApprovalActions = (
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getListApprovalActionsUrl();

  const { fetch } = useFetchableResource<ListApprovalActionsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ListApprovalActions from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /v1/consensus/approval-actions
 */
export const useClearListApprovalActions = () => {
  const url = getListApprovalActionsUrl();

  const { clear } = useFetchableResource<ListApprovalActionsResult>(url);

  return clear;
};

export const useWithOptimisticListApprovalActionsUpdates = () => {
  const url = getListApprovalActionsUrl();

  const { optimisticUpdate } = useFetchableResource<ListApprovalActionsResult>(url);

  return optimisticUpdate;
};
